import { ReactElement } from 'react';

import { DocplannerDoctorMapping } from '@dreryk/egabinet-docplanner-frontend-api';

import { Heading, StyledFlex, Table } from '@dreryk/react-components';

import { doctorsMappingsTranslationKeys } from '../../translations';

import {
   useDoctorsMappingsTableColumnsConfiguration,
   useDoctorsMappingsTableDataConfigurationByCqrsQuery,
   useDoctorsMappingsTableRowDetailsRenderer,
} from './doctorsMappings.hooks';

export const DoctorsMappingsTable = (): ReactElement => {
   const dataConfigurationByCqrsQuery = useDoctorsMappingsTableDataConfigurationByCqrsQuery();
   return (
      <StyledFlex direction={'column'}>
         <Heading content={doctorsMappingsTranslationKeys.label} type={'h2'} testId={'doctorsMappings'} />
         <Table<DocplannerDoctorMapping>
            keyExtractor={'externalDoctorId'}
            testId={'doctorsMappings'}
            columns={useDoctorsMappingsTableColumnsConfiguration(dataConfigurationByCqrsQuery.refetch)}
            dataConfiguration={dataConfigurationByCqrsQuery}
            rowDetailsRenderer={useDoctorsMappingsTableRowDetailsRenderer()}
         />
      </StyledFlex>
   );
};
